export default __webpack_public_path__ + "static/forgery_security_upgrade-59c32f1e49ef2986557380a81afdcdc6.png";